var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:['btn btn-whatsapp', _vm.customClass],attrs:{"href":_vm.linkApi,"target":"_blank"}},[_c('i',{staticClass:"fa-brands fa-whatsapp"}),_vm._v(" "+_vm._s(_vm.btnLabel))])}
var staticRenderFns = []

export { render, staticRenderFns }